import { render, staticRenderFns } from "./UserProfile.vue?vue&type=template&id=2cb87ac4&scoped=true&"
import script from "./UserProfile.vue?vue&type=script&lang=js&"
export * from "./UserProfile.vue?vue&type=script&lang=js&"
import style0 from "./UserProfile.vue?vue&type=style&index=0&id=2cb87ac4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cb87ac4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Kevin\\Documents\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2cb87ac4')) {
      api.createRecord('2cb87ac4', component.options)
    } else {
      api.reload('2cb87ac4', component.options)
    }
    module.hot.accept("./UserProfile.vue?vue&type=template&id=2cb87ac4&scoped=true&", function () {
      api.rerender('2cb87ac4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/User/UserProfile.vue"
export default component.exports